module.exports = __webpack_public_path__ + "static/roberts_michael-8cb70379c75bdff88c2d4a1dbf504879.jpg";